/* REACT */
import React, { useState, useEffect } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import moment from 'moment'
import 'moment/locale/nl'

/* COMPONENTS */

/* STORE */

/* STYLES */
import {
  Title,
  TitleWrapper,
  Description,
  GridItemWrapper,
  DestinationDetailsWrapper,
  DestinationSecondaryDetailsWrapper,
  GridItemDetailsWrapper,
  ItemImageWrapper,
  ItemImage,
} from './style'

/* UTILS/CONSTANTS*/
import { CLOUDFRONT_BASE_URL } from '../../../../utils/constants'
import { Analytics } from '../../../../utils'
import { logAction } from '../../../../utils/actionLogger'

/*ASSETS*/
const NoImage = `${CLOUDFRONT_BASE_URL}/assets/images/NoImage.png`

const DestinationItem = ({
  index,
  isLessThanLaptop,
  item,
  language,
  key,
  itemsPerRow,
  organizationDetails,
}) => {
  // SET MOMENT LOCALE TO CURRENT LANGUAGE
  moment.locale(language)

  const { name, images, description } = item

  const itemImage = images?.length ? images[0]?.url : NoImage

  const mouseDownCoords = e => {
    window.checkForDrag = e.clientX
  }

  const getDescription = () => {
    if (description?.length > 100) {
      if (isLessThanLaptop) return description.substring(0, 150) + '...'
      return description.substring(0, 100) + '...'
    }

    return description
  }

  if (!organizationDetails?.slug) {
    return null
  }

  return (
    <GridItemWrapper
      target={
        organizationDetails?.openNewTabOnClickthroughGrid ? '_blank' : '_self'
      }
      href={item.url}
      onClick={() => {
        logAction({
          name: 'url_click_grid',
          url: item.url,
          linkLabel: name,
        })
      }}
      itemsPerRow={itemsPerRow}
    >
      <GridItemDetailsWrapper>
        <ItemImageWrapper onMouseDown={e => mouseDownCoords(e)}>
          <ItemImage index={index} backgroundImage={itemImage}></ItemImage>
        </ItemImageWrapper>
        <DestinationDetailsWrapper>
          {name ? (
            <DestinationSecondaryDetailsWrapper>
              {name ? (
                <TitleWrapper>
                  <Title>{name}</Title>
                  {description ? (
                    <Description>{getDescription()}</Description>
                  ) : null}
                </TitleWrapper>
              ) : null}
            </DestinationSecondaryDetailsWrapper>
          ) : null}
        </DestinationDetailsWrapper>
      </GridItemDetailsWrapper>
    </GridItemWrapper>
  )
}

const mapStateToProps = state => ({
  organizationDetails: state?.maya?.organizationDetails,
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(DestinationItem)
